namespace $ { $mol_style_attach( "shm/projects/image/viewer/viewer.view.css",
 "[shm_projects_image_viewer] img {\n\tcursor: zoom-in;\n}\n\n[shm_projects_image_viewer] [shm_projects_image_viewer_full] {\n\tcursor: zoom-out;\n}\n"
) }